import { DateType } from "../../data/types/index";
import { dateFormat } from "../../utilities/parseHelper";
import { ScheduleStates } from "../../models/enums/scheduleStates";
import i18n from "@/i18n";
import { ScheduleItem } from "./scheduleItem";

/** Общая модель операции для выписок и истории операций */
export class CreditScheduleModel {
  /** Сумма переплаты */

  public OverpaymentSum: number = 0;

  /** Общая сумма выплат */
  public CreditSum: number = 0;

  public ScheduleList: Array<ScheduleItem> = [];

  public CharCode: string = '';

  constructor(src: any) {
    this.CreditSum = src.Properties.CreditSum ?? 0;
    this.OverpaymentSum = src.Properties.OverpaymentSum ?? 0;
    this.CharCode = src.Properties.currencyCharCode ?? '';
    for (const key in src.InnerData.Data) {
      if (key === "Payments") continue;
      const item = src.InnerData.Data[key].Properties;
      this.ScheduleList.push(new ScheduleItem(item, this.CharCode));
    }
  }
}
